import axios from "axios";
import {showAlert} from './alerts';


export const signup = async (newUser) => {
    try {
        const {data} = await axios.post('/api/v1/users/signup', newUser);
        if(data.status === 'success'){
       
            window.location.assign('/confirm-email');
         
        }
    } catch (error) {
        showAlert('error', error.response.data.message);
        throw error.response.data
    }
}